import { $ } from './../../helpers/query';
import { gsap } from 'gsap';

export default () => {

  $('.downloads').each(section => {

    const form = $('.downloads__subscribe', section);
    const downloads = $('.download', section);

    form.on('submit', (e) => {
      e.preventDefault();
      downloads.addClass('download--unlock');
    });

    downloads.on('click', (e, link) => {
      if (!link.matches('.download--unlock')) {
        e.preventDefault();
        const inputs = form.find('input');
        inputs.elem.focus();
        gsap.to(inputs.elems, {
          'background-color': '#EFCECE',
          duration: 0.4,
          ease: 'power2.out',
          onComplete: () => {
            gsap.to(inputs.elems, {
              'background-color': '#DE9595',
              duration: 0.4,
              ease: 'power2.out',
            });
          }
        });
      }
    });

  });

}
